import { render, staticRenderFns } from "./newaddcheck.vue?vue&type=template&id=7ca6814d&scoped=true&"
import script from "./newaddcheck.vue?vue&type=script&lang=js&"
export * from "./newaddcheck.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=7ca6814d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca6814d",
  null
  
)

export default component.exports